import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AgentSpecialty } from '@workspace/data-types';

export const SPECIALTY_META_MAP: Record<string, { label: string; icon: string }> = {
  [AgentSpecialty.APARTMENT]: { label: 'Appartements', icon: 'apartment' },
  [AgentSpecialty.HOUSE]: { label: 'Maisons & Villas', icon: 'home' },
  [AgentSpecialty.PRESTIGE]: { label: 'Prestige & Luxe', icon: 'diamond' },
  [AgentSpecialty.BUILDING]: { label: 'Immeubles de rapport', icon: 'domain' },
  [AgentSpecialty.LAND]: { label: 'Terrains', icon: 'landscape' },
  [AgentSpecialty.COMMERCIAL]: { label: 'Commerces & Pro', icon: 'storefront' },
};

@Component({
  selector: 'etxe-agent-specialties-display',
  imports: [MatIconModule],
  templateUrl: './agent-specialties-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentSpecialtiesDisplayComponent {
  readonly specialties = input<(AgentSpecialty | string)[] | undefined>(undefined);

  getSpecialtyInfo(key: string): { label: string; icon: string } {
    return SPECIALTY_META_MAP[key] || { label: key, icon: 'category' };
  }
}
